@if (!authService.isEmailVerified() || isLoggingOut()) {
  <div class="verification-backdrop">
    <div class="verification-card">
      @if (isLoggingOut()) {
        <mat-spinner diameter="40" class="mb-4"></mat-spinner>
        <p class="text-sm text-gray-500 font-medium">{{ 'EmailVerification.LoggingOut' | translate }}</p>
      } @else {
        <!-- Logo -->
        <div class="flex justify-center">
          <img class="verification-logo" src="assets/creatives/logo-w70.png" alt="SkillzTank logo" />
        </div>

        <h2 class="text-xl font-bold text-[#1D2433] mb-2 text-center">
          {{ 'EmailVerification.Title' | translate }}
        </h2>

        <!-- Email pill -->
        <div class="verification-email-pill">
          {{ authService.userInfo().email }}
        </div>

        <p class="text-sm text-[#5B6372] leading-relaxed mb-8 text-center">
          {{ 'EmailVerification.Subtitle' | translate }}
        </p>

        <div class="flex flex-col gap-3 w-full">
          <button mat-flat-button color="primary" class="w-full rounded-lg font-semibold" (click)="checkVerification()" [disabled]="isChecking() || isResending()">
            @if (isChecking()) {
              <mat-spinner diameter="18" class="me-2 inline-block align-middle"></mat-spinner>
            }
            {{ 'EmailVerification.BtnCheck' | translate }}
          </button>

          <button mat-stroked-button class="w-full rounded-lg font-medium verification-btn-resend" (click)="resendEmail()" [disabled]="isResending() || isChecking() || resendCooldown() > 0">
            @if (isResending()) {
              <mat-spinner diameter="18" class="me-2 inline-block align-middle"></mat-spinner>
            } @else {
              @if (resendCooldown() > 0) {
                {{ 'EmailVerification.BtnResend' | translate }} ({{ resendCooldown() }}s)
              } @else {
                {{ 'EmailVerification.BtnResend' | translate }}
              }
            }
          </button>

          <button mat-button class="w-full text-[#5B6372] font-medium" (click)="logout()">
            <mat-icon class="me-2">logout</mat-icon>
            {{ 'EmailVerification.BtnLogout' | translate }}
          </button>
        </div>

        <!-- Trust footer (same as login/signup) -->
        <div class="flex items-center justify-center gap-1.5 mt-6 text-gray-400 text-xs">
          <mat-icon class="text-[14px]! h-3.5! w-3.5!">lock</mat-icon>
          <span>{{ 'Sessions.Login.SecureConnection' | translate }}</span>
        </div>
      }
    </div>
  </div>
}

<mat-sidenav-container autosize="false">
  <mat-sidenav #sidenav [mode]="sidenavService.mode()" [opened]="sidenavService.opened()" (openedChange)="sidenavService.opened.set($event)" class="sidenav" [class.bg-white]="isSubMenuOpen()">
    <app-sidebar-nav (closeSidebar)="sidenavService.close()"></app-sidebar-nav>
  </mat-sidenav>

  <mat-sidenav position="end" mode="side" [opened]="videoDrawerOpened()" [disableClose]="videoCallStateService.preventDrawerClose()" (openedChange)="onVideoDrawerOpenedChange($event)" class="global-call-sidenav">
    @if (videoDrawerOpened() && activeCallId()) {
      <app-chime-video-call-drawer [callID]="activeCallId()!" />
    }
  </mat-sidenav>

  <mat-sidenav-content [class.collapsed]="!sidenavService.opened()">
    <!-- Overlay for mobile when menu is open or dragging -->
    @if (sidenavService.mode() === 'over' && (sidenavService.opened() || isDragging())) {
      <div #overlay class="sidenav-overlay" (click)="sidenavService.close()"></div>
    }

    <div class="overlay" [class.drawer-open]="sidenavService.opened()">
      <app-toast></app-toast>
    </div>

    <!-- New Toggle Button (Only visible when closed on desktop AND allowed globally) -->
    @if ((!sidenavService.opened() || sidenavService.isSmallOrTablet()) && sidenavService.showGlobalToggle()) {
      <button
        mat-icon-button
        class="sidenav-toggle-btn toggle-sidebar-btn"
        [class.open]="sidenavService.opened()"
        (click)="sidenavService.toggle()"
        [matTooltip]="(sidenavService.opened() ? 'Global.Close' : 'Global.Open') | translate"
      >
        <mat-icon>{{ sidenavService.opened() ? 'left_panel_close' : 'left_panel_open' }}</mat-icon>
      </button>
    }

    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>

<div class="screenshare-crop-helper"></div>
